<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import Transactions from 'src/components/cabinet/#common/transactions/Transactions.svelte'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte'
    import {myTransactions} from "src/components/cabinet/#services/myTransactions"

    let currentPage = 0
    let perPage = 30
    let transactions
    let loadingTransactions = []
    loadingTransactions.length = perPage

    $: myTransactions.send({ data: { page: currentPage + 1, perPage }})
</script>

<svelte:head>
    <title>Activities transaction</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <div class="page-title">Activities transaction</div>
            {#if $myTransactions.loading}
                <Transactions/>
            {:else if $myTransactions.error || !$myTransactions.hasValue }
                Something went wrong. Try refreshing the page.
            {:else if $myTransactions.hasValue}
                <Transactions transactions={$myTransactions.value.data}/>
                <Pagination bind:currentPage={currentPage} totalCount={$myTransactions.value.totalCount} {perPage}/>
            {/if}
        </div>
    </svelte:fragment>
</MainLayout>
